'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlDocumentPreview", function (security, urlUtils, documentPreview, fileUtils, $http) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      document: "<",
      height: "@",
      documentViewUrl: "@",
      page: "<",
      /* highlightText ne fonctionne pas avec le lecteur pdf emabarqué */
      highlightText: "<"
    },
    template: require("./tlDocumentPreview.html"),
    link: function link($scope, $el, $attrs, $ctrl) {
      $scope.getFileIcon = function (filename) {
        if (!filename) return fileUtils.getExtensionIcon("");
        return fileUtils.getExtensionIcon(fileUtils.getExtension(filename));
      };
      $scope.downloadAttachment = function (attachment) {
        if (!attachment || !attachment.contentBase64) {
          return;
        }
        var byteCharacters = atob(attachment.contentBase64);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], {
          type: attachment.mimeType || 'application/octet-stream'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = attachment.filename || 'attachment';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      };
      var loadEmailDocument = function loadEmailDocument(documentId, extension) {
        $scope.loadingMsg = true;
        $scope.msgError = null;
        $scope.msgData = null;
        var endpoint = extension && extension.toLowerCase() === 'eml' ? 'eml-view' : 'msg-view';
        $http.get('/rest/documents/' + endpoint + '/' + encodeURIComponent(documentId)).then(function (response) {
          $scope.msgData = response.data;
          $scope.loadingMsg = false;
        }).catch(function (error) {
          $scope.loadingMsg = false;
          $scope.msgError = "Impossible de charger le contenu de l'email.";
        });
      };
      $scope.$watch("document", function (document) {
        if (!document) {
          return;
        }
        var documentId = document.id;
        if (!documentId) {
          documentId = document.fileId;
        }
        if ($scope.documentViewUrl) {
          var url = $scope.documentViewUrl;
          // rajout le documentId uniquement si il n'y a pas deja des query params
          if (url.indexOf('?') === -1) {
            url += "/".concat(documentId);
          }
          $scope.documentUrl = urlUtils.addParams(url, security.getTokens());
        } else {
          $scope.documentUrl = document.fileId ? urlUtils.addParams("/rest/documents/view/".concat(document.id), security.getTokens()) : document.url;
        }
        $scope.canPreview = documentPreview.canPreview(document);
        if ($scope.canPreview) {
          var extension = fileUtils.getExtension(document.fileId ? document.fileId : document.url);
          if (_.includes(fileUtils.getPdfExtensions(), extension)) {
            $scope.documentType = "pdf";
          } else if (_.includes(fileUtils.getImagesExtensions(), extension)) {
            $scope.documentType = "image";
          } else if (_.includes(fileUtils.getMsgExtensions(), extension) || extension && extension.toLowerCase() === 'eml') {
            $scope.documentType = "msg";
            loadEmailDocument(documentId, extension);
          } else {
            $scope.documentType = null;
            $scope.canPreview = false;
          }
        }
      });
      $scope.$watch("page", function (newPage) {
        if (newPage) {
          $scope.currentPage = newPage;
        }
      });
      $scope.$watch("highlightText", function (newText) {
        $scope.currentHighlightText = newText;
      });
      if (_.isNumber(parseInt($scope.height))) {
        _.defer(function () {
          $ctrl.setHeight(parseInt($scope.height));
        });
      }
    },
    controller: function controller($scope) {
      var ctrl = this;
      $scope.currentPage = 1;
      $scope.currentHighlightText = null;
      ctrl.setHeight = function (height) {
        $scope.componentHeight = height;
        $scope.$apply(); // PGA: we seems to be out of a digest loop, so forcing...
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/tlDocumentPreview.js
// module id = 2778
// module chunks = 13